export const generatePriceFromChangeProp = (changeInEuroCents?: number) => {
  if (changeInEuroCents) return `${changeInEuroCents / 100}\xa0€`;
  return '0\xa0€';
};
